import axios from 'axios';
import AppConfig from "../../../AppConfig";

let URL = AppConfig.HOST_API() + 'plik/'

export default {

    pobierzPlikPoId(id) {
        return axios({
            method: 'get',
            url: URL + id,
        })
    },

    pobierzListePlikow() {
        return axios({
            method: 'get',
            url: URL + 'list/private',
        })
    },

    pobierzListeTypowPlikow() {
        return axios({
            method: 'get',
            url: URL + 'list/dokumentTyp',
        })
    },

}


// WEBPACK FOOTER //
// ./src/modules/administracja/przegladarka_plikow/PrzegladarkaService.js